import $ from 'jquery';

$('[data-count-characters]').each((_, input) => {
  const $target = $('[data-count-characters-template]', input.parentElement);
  const setText = length => $target.text(
    $target[0].dataset.countCharactersTemplate.replace('{{count}}', length),
  );

  // Set initial value
  setText(input.value.length);

  $(input).on('keyup', event => setText(event.target.value.length));
});
